shadow$provide[414] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vPixelSize;

float getGenericAlpha(float mask) {
  return vPixelSize * 2.0 * (1.0 - mask);
}
`;

};